import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class HttpService {
	constructor(@Inject(HttpClient) private httpClient: HttpClient, @Optional() @SkipSelf() previousInstance?: HttpService ) {
		if (previousInstance) {
			throw new Error(
				'HttpService is already loaded. Import it in the AppModule only');
		}
	}

	// Adaptation d'une requete GET Angular 11 au format de reponse AngularJS
	public get(url: string, params?: any): Promise<any> {
		var result = this.httpClient //
			.get(url, { observe: 'response', params: params }) //
			.pipe(
				map(
					response => ({ ...response, data: response.body })
				),
				catchError(
					error => of({ ...error, data: error.error })
				)) //
			.toPromise() //
			;
		return result;
	}

	// Adaptation d'une requete GET Angular 11 au format de reponse AngularJS, avec un format de reponse arraybuffer
	public getAsArrayBuffer(url: string, params?: any): Promise<any> {
		var result = this.httpClient //
			.get(url, { observe: 'response', responseType: 'arraybuffer', params: params }) //
			.pipe(
				map(
					response => ({ ...response, data: response.body })
				),
				catchError(
					error => of({ ...error, data: error.error })
				)) //
			.toPromise() //
			;
		return result;
	}

	// Adaptation d'une requete PUT Angular 11 au format de reponse AngularJS
	public put(url: string, data: any): Promise<any> {
		let headers = new HttpHeaders({
			'Content-Type': 'application/json',
		});

		var result = this.httpClient //
			.put(url, data, { headers: headers, observe: 'response' }) //
			.pipe(
				map(
					response => ({ ...response, data: response.body })
				),
				catchError(
					error => of({ ...error, data: error.error })
				)) //
			.toPromise() //
			;
		return result;
	}

	// Adaptation d'une requete POST Angular 11 au format de reponse AngularJS
	public post(url: string, data: any, params?: any): Promise<any> {
		let headers = new HttpHeaders({
			'Content-Type': 'application/json',
		});

		var result = this.httpClient //
			.post(url, data, { headers: headers, observe: 'response', params: params }) //
			.pipe(
				map(
					response => ({ ...response, data: response.body })
				),
				catchError(
					error => of({ ...error, data: error.error })
				)) //
			.toPromise() //
			;
		return result;
	}

	// Adaptation d'une requete DELETE Angular 11 au format de reponse AngularJS
	public delete(url: string): Promise<any> {
		var result = this.httpClient //
			.delete(url, { observe: 'response' }) //
			.pipe(
				map(
					response => ({ ...response, data: response.body })
				),
				catchError(
					error => of({ ...error, data: error.error })
				)) //
			.toPromise() //
			;
		return result;
	}
}